import step4Style from "./step4.module.css"
import Nav from "./nav"
import { useLayoutEffect, useRef, useState } from "react"
import { useLocation } from "react-router"

import Pay from "./step4/pay"

import Loading from "consumer/setup/loading"

import { check_apply } from "consumer/@@@/check_apply"


export default function Step4() {

    const location = useLocation()
    const consumer_id = location.state.consumer_id

    const isMounted = useRef(0)

    const [info, Set_info] = useState(null)

    const [loading, Set_loading] = useState(true)

    useLayoutEffect(() => {
        if(isMounted.current === 0) {
            check_apply({
                consumer_id: consumer_id,
                Set_info: Set_info,
                isMounted: isMounted
            })
        }
    }, [])

    useLayoutEffect(() => {
        if(isMounted.current === 1) {
            Set_loading(false)
        }
    }, [info])

    return(
        <div
            id="step4"
            className={step4Style['step4']}
        >
            <Nav
                step={4}
            ></Nav>

            <Loading
                loading={loading}
            ></Loading>

            {info !== null &&
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        padding: "10px",
                        boxSizing: "border-box",
                        marginTop: "30px"
                    }}
                >
                    <div style={{marginBottom: "20px"}}>
                        <div
                            style={{
                                marginBottom: "10px"
                            }}
                        >결제 금액</div>
                        <div
                            style={{
                                fontSize: "30px",
                                fontWeight: "bold",
                                textAlign: "right"
                            }}
                        >{info['Schedule']['payment']}원</div>
                    </div>

                    <Pay
                        consumer_id={consumer_id}
                    ></Pay>
                </div>
            }
        </div>
    )
}